export const favoriteQuestionApiUrls = {
	addFavoriteQuestion: '/questions/favorites/:profileId/:questionId',
	resetFavoriteQuestion: '/questions/favorites/:profileId/:questionId',
};
